import { _ as c } from "./DynamicScroller.vue_vue_type_script_setup_true_lang-yssX6Q5B.js";
import { _ as l } from "./DynamicScrollerItem.vue_vue_type_script_setup_true_lang-qh6MY0wl.js";
import { _ as m } from "./RecycleScroller.vue_vue_type_script_setup_true_lang-C7mZBLYi.js";
import "./scroller.css_vue_type_style_index_0_src_true_lang--7gJ3zh_.js";
import { _ as t } from "./WindowScroller.vue_vue_type_script_setup_true_lang-C3nM_XUB.js";
import { c as s } from "./useRecycleScroller-D_RDrEg2.js";
import { u as D } from "./useRecycleScroller-D_RDrEg2.js";
import { useDynamicScroller as C } from "./composables/useDynamicScroller.js";
import { useDynamicScrollerItem as W } from "./composables/useDynamicScrollerItem.js";
import { useIdState as R } from "./composables/useIdState.js";
import { useTableColumnWidths as P } from "./composables/useTableColumnWidths.js";
import { useWindowScroller as h } from "./composables/useWindowScroller.js";
function i(o, e) {
  o.component(`${e}recycle-scroller`, m), o.component(`${e}RecycleScroller`, m), o.component(`${e}dynamic-scroller`, c), o.component(`${e}DynamicScroller`, c), o.component(`${e}dynamic-scroller-item`, l), o.component(`${e}DynamicScrollerItem`, l), o.component(`${e}window-scroller`, t), o.component(`${e}WindowScroller`, t);
}
const d = {
  version: "3.0.5",
  install(o, e) {
    const n = { installComponents: !0, componentsPrefix: "", ...e };
    for (const r in n)
      typeof n[r] < "u" && (s[r] = n[r]);
    n.installComponents && i(o, n.componentsPrefix);
  }
};
export {
  c as DynamicScroller,
  l as DynamicScrollerItem,
  m as RecycleScroller,
  t as WindowScroller,
  d as default,
  C as useDynamicScroller,
  W as useDynamicScrollerItem,
  R as useIdState,
  D as useRecycleScroller,
  P as useTableColumnWidths,
  h as useWindowScroller
};
//# sourceMappingURL=vue-virtual-scroller.js.map
